<script>
export default {
  props: {
    sources: {
      type: Array,
      required: true,
    },
    poster: {
      type: String,
      default: '',
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.initPlayer();
  },

  methods: {
    initPlayer() {
      const videoPlayer = this.$refs.video;
      if (videoPlayer) {
        new Toolkit.VideoPlayer(videoPlayer, {
          plyr: false,
        });
      }
    },
  },
};
</script>

<template>
  <div
    ref="video"
    class="video-player product-card-media-content__item product-card-media-content__item--default video-player--cover"
  >
    <video :poster="poster" :autoplay="autoplay" :muted="muted" :loop="loop" playsinline>
      <source v-for="(source, key) in sources" :key="key" :src="source.src" :type="source.type" />
    </video>
  </div>
</template>
